import RLMSDetails from "./rates/RLMSDetails";
import RSDetails from "./rates/RSDetails";
import TOUDetails from "./rates/TOUDetails";

import residentialService from "./rates/residentialService";
import residentialLoadManagementService from "./rates/residentialLoadManagementService";
import residentialTimeOfUse from "./rates/residentialTimeOfUse";

//OBS: For the rates data, the max and min ALWAYS need to have 12 elements.
const rates = {
  RS: {
    id: 'RS',
    title: ['Residential Service (RS)'],
    subTitle: [''],
    data: residentialService,
    detailsComponent: RSDetails,
  },
  RLMS: {
    id: 'RS w/ Off Peak Credit',
    title: ['Residential Service w/ Off-Peak Credit'],
    subTitle: [''],
    data: residentialLoadManagementService,
    detailsComponent: RLMSDetails,
  },
  TOU: {
    id: 'TOU',
    title: ['Time-Of-Use (TOU)'],
    subTitle: [''],
    data: residentialTimeOfUse,
    detailsComponent: TOUDetails,
  },
};

export default rates;
